import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MaintenanceBanner from "../Components/MaintenanceBanner";
import "./Layout.css";

const Layout = () => {
  return (
    <>
      <Navbar />
      <MaintenanceBanner />
      <main className="app-container">
        <Outlet />
      </main>
      {/* footer */}
      <Footer />
    </>
  );
};

export default Layout;
